function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { selectAnatomy as parts } from "../chakra/internal";
import { mergeWith } from "../chakra/internal";
import { ThemedInput as Input } from "./Input";
const baseStyleField = _object_spread({}, Input.baseStyle.field);
const baseStyleIcon = {
    width: 'icon.m',
    height: '100%',
    insetEnd: 'spacing.s',
    position: 'relative',
    color: 'currentColor'
};
const baseStyle = {
    field: baseStyleField,
    icon: baseStyleIcon
};
const iconSpacing = {
    pe: 'spacing.2xl'
};
const sizes = mergeWith({}, Input.sizes, {
    small: {
        field: iconSpacing
    },
    medium: {
        field: iconSpacing
    }
});
export const ThemedSelect = {
    parts: parts.keys,
    baseStyle,
    sizes,
    variants: Input.variants,
    defaultProps: Input.defaultProps
};

//# sourceMappingURL=Select.js.map